import { ICommandBase } from '@/commands/interface/iCommandBase';
import { PatternBaseLayer } from '@/model/document2/page/surface/design/layer/patternBaseLayer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';

// 図形のグラデーション位置変更コマンド
export class ChangeGradationPositionOfPatternCommand implements ICommandBase
{
    private layer! : PatternBaseLayer | PolygonLayer;
    private index! : number;
    private position! : number;
    private doneCallback! : () => void;

    private oldPosition : number = 0;

    private newIndex : number = 0;

    constructor(layer : PatternBaseLayer | PolygonLayer, index : number, position : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.position = position;
        this.doneCallback = doneCallback;

        // 現在の位置
        this.oldPosition = layer.getGradation(index).position;
    }

    public do() : void
    {
        // グラデーション位置変更
        this.newIndex = this.layer.changeGradationPosition(this.index, this.position);
        // 新しい位置に選択を変更
        this.layer.selectedGradationPoint = this.newIndex;

        this.doneCallback();
    }

    public undo() : void
    {
        // グラデーション色変更
        this.layer.changeGradationPosition(this.newIndex, this.oldPosition);
        // 選択を戻す
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }

    public redo() : void
    {
        // グラデーション位置変更
        this.newIndex = this.layer.changeGradationPosition(this.index, this.position);
        // 新しい位置に選択を変更
        this.layer.selectedGradationPoint = this.newIndex;

        this.doneCallback();
    }
}